import { createFileRoute } from "@tanstack/react-router";
import { EnvPreset } from "gfx/EnvPreset";
import { envPresetSceneLights } from "gfx/sceneLights";
import withCustomizer from "lib/state/withCustomizer";
import {
  addBuildingRendererTestGeometry,
  BUILDING_RENDERER_TEST_CAMERA_SETTINGS,
  BUILDING_RENDERER_TEST_KEYS,
} from "test/util/buildingRendererTestUtil";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import withAuthentication from "../../components/withAuthentication";

function BuildingRendererPage() {
  const options = {
    gui: false,
    ssfxRenderer: true,
    animate: true,
    sceneLights: envPresetSceneLights[EnvPreset.WHITEBOX],
    debugFeaturesEnabled: false,
    cameraSettings: BUILDING_RENDERER_TEST_CAMERA_SETTINGS,
    useMSAA: false,
  };

  return (
    <HeadlessRenderTestPage
      testName="Building Renderer"
      options={options}
      testKeys={BUILDING_RENDERER_TEST_KEYS}
      addGeometry={addBuildingRendererTestGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/building-renderer")({
  component: withAuthentication(withCustomizer(BuildingRendererPage), { superAdmin: true }),
});
